import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  validateAddresses: {
    description: 'orderDrawer.validateAddresses.validateAddresses',
    defaultMessage: 'Revalidate Addresses',
    id: 'R4ylkJ',
  },
  notValidated: {
    description: 'orderDrawer.validatedAddresses.notValidated',
    defaultMessage: 'not validated',
    id: 'vIEGUL',
  },
  succeeded: {
    description: 'orderDrawer.validatedAddresses.succeeded',
    defaultMessage: 'succeeded',
    id: 'LveIKM',
  },
  error: {
    description: 'orderDrawer.validatedAddresses.error',
    defaultMessage: 'error',
    id: 'BgGDAD',
  },
  warning: {
    description: 'orderDrawer.validatedAddresses.warning',
    defaultMessage: 'warning',
    id: 'Mez2sG',
  },
  errors: {
    description: 'orderDrawer.validatedAddresses.errors',
    defaultMessage: 'errors',
    id: 'ATXBVO',
  },
  warnings: {
    description: 'orderDrawer.validatedAddresses.warnings',
    defaultMessage: 'warnings',
    id: 'it7JqX',
  },
  revalidateButton: {
    description: 'orderDrawer.validatedAddresses.revalidateButton',
    defaultMessage: 'Revalidate Selected Address',
    id: 'tDMDGW',
  },
  multipleAddresses: {
    description: 'orderDrwaer.validatedAddresses.multipleAddresses',
    defaultMessage: 'Multiple Addresses',
    id: 'Wq35WG',
  },
});
